import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { LOCATIONS, API_PATH } from '../constants'

const deleteLocation = async (id: number) => {
  await fetchAPI({
    path: `${API_PATH}/${id}`,
    method: 'delete',
  })
}

export const useDeleteLocation = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteLocation, {
    async onSuccess() {
      await queryClient.refetchQueries([LOCATIONS])

      toast({
        description: t('views.admin.campaigns.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
